export const getEnquiry = (state) => state.enquiry;
export const getStatus = (state) => state.enquiry?.status;
export const getCaseNumber = (state) => state.enquiry?.enquiry?.caseNumber;
export const getCallbackRequest = (state) => state.enquiry?.callbackRequest;
